import React, {useEffect, useState} from 'react';
import SelectPhone
    from "components/formcomponents/SelectPhone";
import {Information} from "assets/icons";
import useFetchData from "hooks/useFetchData";
import ApiDatabase from 'server'
import {toast} from "react-toastify";
import UseContext from "hooks/useContext";
import Button from "components/button";

const MyAccountPersonalContent = () => {
    const {userData}=useFetchData()
    const {refreshLoadWorker} = UseContext()
    const [validPhone, setValidPhone] = useState(false);
    const [errMsgPhone, setErrMsgPhone] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const contentAdmin={
        200:'Observateur',
        205:'Manageur',
        210:'Responsable',
        215:'Directeur',
        220:'Superviseur',
        225:'Administrateur'
    }
useEffect(()=>{
    if (userData?.phone?.length > 0) {
        setPhone(userData.phone)
    }
},[userData])

    const handleConfirm = (e) => {
        e.preventDefault();
        if (isSaving) return;

        const nextPhone = phone?.phone ?? phone;
        if (!nextPhone || nextPhone === userData?.phone) {
            toast.info('Aucune modification à enregistrer.');
            return;
        }

        setIsSaving(true);
        ApiDatabase.postUpdatePhone(
            {
                token: localStorage.getItem('xsrfToken'),
                phone: nextPhone
            },
            () => {
                toast.success('Le numéro de téléphone a été modifié.');
                // garder la source de vérité (hook) en sync via refresh
                refreshLoadWorker();
                setIsSaving(false);
            },
            (err) => {
                console.log(err);
                toast.error('Une erreur est survenue lors de la mise à jour.');
                setIsSaving(false);
            }
        );
    };
    return (
        <div className="w-full px-2 tab:px-4 lg:px-8 py-8">
            <div className="flex flex-col gap-8 max-w-3xl">
                <div className="flex flex-col gap-6">
                    <h2 className="text-xl font-semibold text-gray-900">Informations personnelles</h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Nom</label>
                            <input
                                type="text"
                                value={userData.lastname}
                                name="lastname"
                                className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                                disabled
                            />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Prénom</label>
                            <input
                                type="text"
                                value={userData.firstname}
                                name="firstname"
                                className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                                disabled
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Poste dans l’entreprise</label>
                            <input
                                type="text"
                                value={contentAdmin[userData.role]}
                                name="role"
                                className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                                disabled
                            />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Numéro</label>
                            <div className="relative">
                                <SelectPhone
                                    phoneValue={phone}
                                    setPhoneValue={setPhone}
                                    setValidPhone={setValidPhone}
                                    setErrMsgPhone={setErrMsgPhone}
                                />
                            </div>
                            <p className={errMsgPhone ? "text-yellow-600 flex flex-row gap-2 items-center ft-sm mt-1" : "hidden"}>
                                <Information wh={15} color={'#FF9600'}/>
                                Numéro invalide
                            </p>
                        </div>
                    </div>

                    <div className="flex justify-start pt-2">
                        <Button
                            size="SM"
                            color="PRIMARY"
                            onClick={handleConfirm}
                            disabled={isSaving || errMsgPhone}
                        >
                            {isSaving ? 'Enregistrement...' : 'Confirmer'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyAccountPersonalContent;